export default "__VITE_ASSET__CGaYXsVo__"